import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputBlock from 'components/connectedForm/InputBlock';
import InputGroup from 'components/connectedForm/InputGroup';
import InputLabel from 'components/connectedForm/InputLabel';
import InputErrorMessage from 'components/connectedForm/InputErrorMessage';

export default class ToggleButtonInput extends Component {
  render() {
    const {
      active,
      id,
      label,
      includeLabel,
      inGrid,
      flexBox,
      labelCols,
      inputCols,
      readOnly,
      hint,
      message,
      showWhenNotActive,
      onChange,
      touched,
      customValidationErrors,
      checkedLabel,
      uncheckedLabel,
    } = this.props;

    const labelProps = {
      flexBox,
      id,
      includeLabel,
      hint,
      label,
      readOnly,
    };
    const checked = this.props.value;
    const ToggleButtonInput = (
      <div className="toggleButton" key="delete" onClick={() => onChange(!checked)}>
        {checked ? (
          <i style={{ color: '#808080' }} className="icon">
            arrow_drop_down
          </i>
        ) : (
          <i className="icon">arrow_drop_up</i>
        )}
      </div>
    );
    if (inGrid) return ToggleButtonInput;

    return (
      <InputBlock flexBox={flexBox}>
        <InputLabel {...labelProps} cols={labelCols} />
        <InputGroup flexBox={flexBox} cols={inputCols} withLabel={includeLabel}>
          {ToggleButtonInput}
          <InputErrorMessage
            active={active}
            touched={touched}
            message={message}
            showWhenNotActive={showWhenNotActive}
            customValidationErrors={customValidationErrors}
          />
        </InputGroup>
      </InputBlock>
    );
  }
}

ToggleButtonInput.propTypes = {
  active: PropTypes.bool,
  mandatory: PropTypes.bool,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  includeLabel: PropTypes.bool,
  readOnly: PropTypes.bool,
  flexBox: PropTypes.bool,
  labelCols: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  inputCols: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  hint: PropTypes.string,
  value: PropTypes.bool,
  message: PropTypes.array,
  showWhenNotActive: PropTypes.bool,
  label: PropTypes.string,
};

ToggleButtonInput.defaultProps = {
  active: false,
  mandatory: false,
  onBlur: () => {},
  onFocus: () => {},
  onChange: () => {},
  includeLabel: true,
  readOnly: false,
  flexBox: true,
  labelCols: 'min',
  inputCols: 'max',
  value: false,
  message: [],
  hint: '',
  showWhenNotActive: false,
  label: '',
  id: '',
};
